module.exports = __webpack_public_path__ + "img/ice2.4574ff9d.png";